export const resultScreen = {
    'primary': {
        'top_threshold': {
            'title': 'Amazing!',
            'score_text': ' and won a gold medal.',
            'continue_button_style': 'btn-primary',
            'review_button_style': 'review-btn'
        },
        'middle_threshold': {
            'title': 'Keep it up!',
            'score_text': ' and won a gold medal.',
            'continue_button_style': 'btn-primary',
            'review_button_style': 'review-btn',
            'tryagain_button_style': 'tryAgain-btn'
        },
        'bottom_threshold': {
            'title': 'Great start!',
            'score_text': '. Try again and go for gold.',
            'continue_button_style': 'btn-primary',
            'review_button_style': 'review-btn',
            'tryagain_button_style': 'tryAgain-btn'
        }
    },
    'secondary': {
        'top_threshold': {
            'title': 'Amazing!',
            'score_text': ' and won a gold medal.',
            'continue_button_style': 'btn-primary',
            'review_button_style': 'review-btn'
        },
        'middle_threshold': {
            'title': 'Keep it up!',
            'score_text': ' and won a gold medal.',
            'continue_button_style': 'btn-primary',
            'review_button_style': 'review-btn',
            'tryagain_button_style': 'tryAgain-btn'
        },
        'bottom_threshold': {
            'title': 'Good effort!',
            'score_text': '. Try again and go for gold.',
            'continue_button_style': 'btn-primary',
            'review_button_style': 'review-btn',
            'tryagain_button_style': 'tryAgain-btn'
        }
    },
    'adult': {
        'top_threshold': {
            'title': 'Amazing!',
            'continue_button_style': 'btn-primary',
            'review_button_style': 'review-btn',
            'tryagain_button_style': 'tryAgain-btn'
        },
        'middle_threshold': {
            'title': 'Keep it up!',
            'continue_button_style': 'btn-primary',
            'review_button_style': 'review-btn',
            'tryagain_button_style': 'tryAgain-btn'
        },
        'bottom_threshold': {
            'title': 'Good effort!',
            'continue_button_style': 'btn-primary',
            'review_button_style': 'review-btn',
            'tryagain_button_style': 'tryAgain-btn'
        }
    }
}
